import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type freeToStandardModalQuery,
	type GrowthRecContext,
	type JiraApplicationKey,
	type JiraProjectType,
} from './__generated__/freeToStandardModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	isConfluence: boolean;
	isJira: boolean;
	isServiceCollectionFree?: boolean;
	isTwcSkuRecommendationEnabled?: boolean;
	jiraApplicationKey: JiraApplicationKey;
	projectType: JiraProjectType;
	recommendationContext?: GrowthRecContext | null;
};

export type FreeToStandardModalExtraProps = {
	recommendationSessionId?: string;
};

type FreeToStandardModalComponent = EntryPointComponent<
	{
		freeToStandardModalQuery: freeToStandardModalQuery;
	},
	Record<string, never>,
	{
		onClose: () => void;
	},
	FreeToStandardModalExtraProps
>;

export const entryPoint: EntryPoint<FreeToStandardModalComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<FreeToStandardModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-free-to-standard-modal" */ './free-to-standard-modal',
			{
				moduleId: 'edition-awareness-free-to-standard-modal',
			},
		),
		getPreloadProps: ({
			cloudId,
			projectType,
			jiraApplicationKey,
			isJira,
			isConfluence,
			isServiceCollectionFree = false,
			isTwcSkuRecommendationEnabled = false,
			recommendationContext = null,
		}: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {
				recommendationSessionId: isTwcSkuRecommendationEnabled
					? (recommendationContext?.sessionId ?? undefined)
					: undefined,
			},
			queries: {
				freeToStandardModalQuery: {
					parameters,
					variables: {
						cloudId,
						jiraApplicationKey,
						projectType,
						isJira,
						isConfluence,
						isServiceCollectionFree,
						isTwcSkuRecommendationEnabled,
						recommendationContext,
					},
				},
			},
		}),
	});
